import type { SignUpFormValues } from '../schemas';

import { OwnerType } from '../models/enums';

/**
 * Whether the user is signing up as an individual rather than as a business.
 *
 * Keyed off the answer the user gave, never off the business fields: sign up is one
 * long-lived form, so a structure picked in an abandoned business branch can outlive
 * the answer that produced it (PWA-16156).
 *
 * @param formValues - Sign up form values
 */
export function isIndividualSignUp(formValues: Pick<SignUpFormValues, 'ownerType'>): boolean {
  return formValues.ownerType === OwnerType.INDIVIDUALS;
}
